import { h, Host } from "@stencil/core";
import { SpinnerOverlayStatusEnum } from "./spinner-overlay-status";
import { LoaderVariant } from "../loader/loader.enum";
export class SpinnerOverlay {
    constructor() {
        this.opened = false;
        this.headline = undefined;
        this.subline = undefined;
        this.status = SpinnerOverlayStatusEnum.CLOSED;
    }
    // @ts-expect-error Check for typing
    transitionTimeout = null;
    setOverlayStatus() {
        if (this.transitionTimeout !== null) {
            clearTimeout(this.transitionTimeout);
        }
        if (this.opened) {
            if (this.status === SpinnerOverlayStatusEnum.OPENED) {
                return;
            }
            this.status = SpinnerOverlayStatusEnum.OPENING;
            this.transitionTimeout = setTimeout(() => {
                this.status = SpinnerOverlayStatusEnum.OPENED;
            }, 100);
        }
        else {
            if (this.status === SpinnerOverlayStatusEnum.CLOSED) {
                return;
            }
            this.status = SpinnerOverlayStatusEnum.CLOSING;
            this.transitionTimeout = setTimeout(() => {
                this.status = SpinnerOverlayStatusEnum.CLOSED;
            }, 350);
        }
    }
    componentWillLoad() {
        this.setOverlayStatus();
    }
    render() {
        const renderSpinner = this.status !== SpinnerOverlayStatusEnum.CLOSED;
        const displayMessage = this.headline || this.subline;
        return (h(Host, { key: '3a4a4326fbc87a1bb8046013dfbd796f79a99726', status: this.status, role: "alert", "aria-busy": "true" }, h("div", { key: '28f9e35079cf93312e3c5906a8119bd1c81f29d4', class: "backdrop" }, renderSpinner && !displayMessage && h("ux-loader", { key: '4404575d5e3aa23becfd5444d0932fc1f3a15800', class: "loader", variant: LoaderVariant.Spinner }), renderSpinner && displayMessage && (h("div", { key: '05a9b57a7127df9316204e75d04c491f37eb6edc', class: "container" }, h("h2", { key: '2de83678a3c1e392d74b4eb5d551ebb9cdc047c7', class: "headline" }, this.headline), h("ux-loader", { key: '635b2f86a862c40afeaf7ed3e670521237a74f05', variant: LoaderVariant.Spinner }), h("p", { key: '7a038bef9e486d6d8fa47770c18508b08b25d87f', class: "subline" }, this.subline))))));
    }
    static get is() { return "ux-spinner-overlay"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["spinner-overlay.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["spinner-overlay.css"]
        };
    }
    static get properties() {
        return {
            "opened": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "prop",
                            "text": "{boolean} opened - A boolean property that reflects the current state of the spinner-overlay.\nIf `true`, the spinner-overlay is open. If `false`, the spinner-overlay is closed. Default value is `false`."
                        }],
                    "text": "Represents whether the spinner-overlay is currently open."
                },
                "attribute": "opened",
                "reflect": true,
                "defaultValue": "false"
            },
            "headline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "prop",
                            "text": "{string} headline - A string property that sets the headline\nThis headline provides a brief, concise description of the loading state"
                        }],
                    "text": "Represents the headline displayed in the spinner."
                },
                "attribute": "headline",
                "reflect": false
            },
            "subline": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "prop",
                            "text": "{string} subline - A string property that sets the subline\nThis subline provides additional information or details about the loading state"
                        }],
                    "text": "Represents the subline displayed in the spinner."
                },
                "attribute": "subline",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "status": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "opened",
                "methodName": "setOverlayStatus"
            }];
    }
}
//# sourceMappingURL=spinner-overlay.js.map
